import { ElasticProxy } from "./proxies";
import Axios from "axios";
import { reportIfInvalidSession } from "../invalid-session";
import { beginTelemetryApiCall } from "../../@core/telemetry/telemetry-bridge";

interface Options {
    timeout?: number;
    headers?: Record<string, string>;
    resultParser?: (result: any) => any;
    errorParser?: (error: any) => any;
}

export const HTTPProxy = (url: string, options: Options = {}) => 
    ElasticProxy.newRecursive({
        recursive:  true,
        
        async apply (path: string[], args: any[]) {
            return new Promise (async (resolve, reject) => {
                const reqpath = url + "/" + path.join("/").toLowerCase();
                const telemetry = beginTelemetryApiCall(path);
                if (options.timeout) {
                    setTimeout(() => reject(new Error("Request " + reqpath + " timed out")), options.timeout);
                }
                try {
                    const response = await Axios.post(
                        reqpath,
                        args,
                        { headers: { Accept: 'application/json', ...(options.headers ?? {}), ...(telemetry?.headers ?? {}) } }
                    );
                    telemetry?.end({ ok: true, status: response.status });
                    
                    if (options.resultParser) resolve(await options.resultParser(response.data));
                    else resolve(response.data.result);
                } catch (exc: any) {
                    telemetry?.end({ ok: false, status: exc?.response?.status, code: exc?.response?.data?.code });
                    reportIfInvalidSession(exc?.response?.data?.message ?? exc?.response?.data?.error, args);
                    if (options.errorParser) reject("Request " + reqpath + " failed: " + options.errorParser(exc));
                    else if (exc.response && exc.response.data && exc.response.data.error && typeof exc.response.data.error === "string") 
                        reject(new Error(exc.response.data.error));
                    else if (exc.response && exc.response.data && exc.response.data.error)
                        reject(new Error(JSON.stringify(exc.response.data.error)));
                    else if (exc.response && exc.response.data && exc.response.data.message)
                        reject(new Error(exc.response.data.message));
                    else if (exc.response && exc.response.status)
                        reject(new Error(exc.response.status));
                    else
                        reject(new Error(exc.message));
                }
            });
        }

});